// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"93":"3291192c","132":"9ec63f86","139":"eec06aa5","228":"2d2a9ded","245":"ddb1d2c9","258":"899a58a9","533":"155a98c8","764":"f095c84d","914":"94e9eec3"}[chunkId] + ".js";
};